import { inject, Injectable, signal } from '@angular/core';
import {
  AppConfigService,
  ApplicationConfig
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  APP_DISABLE_LEGACY = true;
  enableMachCoreLoginModal = signal(false);

  private applicationConfig = inject(ApplicationConfig);
  private appConfig = inject(AppConfigService);

  checkDisableLegacy(): void {
    const configValue =
      this.applicationConfig.get('APP') === 'static' ? false : true;
    this.APP_DISABLE_LEGACY = configValue;
  }

  checkEnableMachCoreLoginModal(): void {
    const configValue =
      !!this.appConfig.getConfig('LOGIN_MODAL').ENABLE_MACH_CORE_LOGIN_MODAL;
    this.enableMachCoreLoginModal.set(configValue);
  }
}
